import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

const salesDashboard = combineReducers({
  data,
  state,
});

export default salesDashboard;
